/**
 * this is the global application where all common modules like login and logout should inherit from
 **/
export default class AppController {
	/**
	 * define required services here
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		this.Socket = $injector.get('socket');
		this.AppConfig = $injector.get('app.config');
		this.ToastService = $injector.get('ToastService');
		this.$window = $injector.get('$window');
	}

	/**
	 * initialize the component and define some event listeners to check the app version
	 **/
	$onInit() {
		this.registerEvents();
	}

	registerEvents() {
		this.Socket.on('socket:version:checkAppVersion', (data) => {
			this.Socket.emit('version:checkMyAppVersion', this.AppConfig.app);
		});

		this.Socket.on('socket:version:versionOutdated', (data) => {
			this.ToastService.action('Neue Version verfügbar. Bitte neu laden.', 'Neu laden', () => {
				this.$window.location.reload(true);
			});
		});

		this.Socket.on('socket:message:show', (data) => {
			this.ToastService.action(data.msg, 'OK', () => {
				this.ToastService.hide();
			});
		});
	}

}
